import React, { createContext, useContext, useState, useCallback } from "react"

const SearchContext = createContext(null)

export function SearchProvider({ children }) {
  const [globalSearchQuery, setGlobalSearchQuery] = useState("")
  const [isSearchFocused, setIsSearchFocused] = useState(false)

  const updateSearchQuery = useCallback((query) => {
    setGlobalSearchQuery(query)
  }, [])

  const clearSearchQuery = useCallback(() => {
    setGlobalSearchQuery("")
  }, [])

  return (
    <SearchContext.Provider
      value={{
        globalSearchQuery,
        updateSearchQuery,
        clearSearchQuery,
        isSearchFocused,
        setIsSearchFocused,
      }}
    >
      {children}
    </SearchContext.Provider>
  )
}

export function useSearch() {
  const context = useContext(SearchContext)
  if (!context) {
    throw new Error("useSearch must be used within a SearchProvider")
  }
  return context
}
